<nav class="navbar top-navbar navbar-expand-md navbar-dark">
  <div class="navbar-header">
    <a class="navbar-brand" href="index.html">
      <img src="assets/images/logomini.png" width="50" alt="homepage" class="dark-logo" />
    </a>
  </div>
  <div class="navbar-collapse">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item hidden-sm-up">
        <a class="nav-link nav-toggler waves-effect waves-light" href="javascript:void(0)">
          <i class="ti-menu"></i>
        </a>
      </li>
      <li class="nav-item search-box">
        <h4 class="ml-2 mb-0 header-tittle text-white">Contractors Management</h4>
        <ol class="breadcrumb mb-0 hide-menu claroredbg">
          <li class="breadcrumb-item">
            <a class="text-white" [routerLink]="['/home']">Home</a>
          </li>
          <!--li class="breadcrumb-item active text-white">{{ 'languageService.titleTotal' }}</li-->
        </ol>
      </li>
    </ul>
    <ul class="navbar-nav my-lg-0">
      @if (false) {
        <li class="nav-item dropdown mega-dropdown">
          <a class="nav-link waves-effect waves-dark" href="">
            <i class="ti-help"></i>
          </a>
        </li>
      }
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src="assets/images/users/default_profile.png" alt="user" class="img-circle" width="30">
        </a>
        <div class="dropdown-menu dropdown-menu-right user-dd animated flipInY">
          <span class="with-arrow"><span class="bg-primary"></span></span>
          <div class="d-flex no-block align-items-center p-15 bg-primary text-white m-b-10">
            <div>
              <img src="assets/images/users/default_profile.png" alt="user" class="img-circle" width="60">
            </div>
            <div class="m-l-10">
              <h4 class="m-b-0">{{ name }}</h4>
              <p class=" m-b-0">{{ user }}</p>
            </div>
          </div>
          <button (click)="logoutUser()" class="dropdown-item">
            <i class="mdi mdi-logout m-r-5 m-l-5"></i> Logout
          </button>
        </div>
      </li>
    </ul>
  </div>
</nav>
